import React, { useState, useEffect } from "react";
import DrawerRight from "../ui/DrawerRight";
//import { Device } from "twilio-client";
import { Device } from "@twilio/voice-sdk";
import axios from "axios";
import { FaWordpress, FaPhone, FaTimes, FaTimesCircle, FaFileInvoiceDollar, FaPhoneAlt, FaMoneyBillWave, FaUser, FaRegCalendarAlt, FaBoxOpen, FaSearch, FaQuestionCircle, FaMicrophone, FaStp, FaPlay, FaPause, FaTrash, FaPen, FaUpload, FoaFileAudio } from "react-icons/fa";
import contrycodes from "../../constants/countrycodes.json";
import { MdClose } from "react-icons/md";
import { WEBHOOK } from "../../config/configEnvs";
import IncomingCall from "./IncomingCall";
import OnCall from "./OnCall";
import { useSelector, useDispatch } from "react-redux";
import { setCallEnded } from "../../features/twilioPhoneSlice";
import Selector from "../ui/components/Selector";
import { CalculateUserCategory } from "../../utils/helpers/CalculateUserCategory";
import callReasons from "../../utils/plainValues/CallReasons";
import InputFormValue from "../ui/components/InputFormValue";
import { FaNoteSticky } from "react-icons/fa6";
import { FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Checkbox, CircularProgress } from "@mui/material";

const TwilioPhoneDrawer = ({ open, onClose, setOpen, services }) => {

  const user = useSelector((state) => state.auth.user);
  const { client, quoteId } = useSelector((state) => state.twilioPhone);
  const dispatch = useDispatch();

  const [device, setDevice] = useState(null); // Dispositivo de Twilio

  const [callState, setCallState] = useState(""); // Estado de la llamada, texto
  const [callStatus, setCallStatus] = useState(""); // Estado de la llamada
  const [phone, setPhone] = useState(""); // Número de telefono al cual se está llamando
  const [dialCode, setDialCode] = useState("+51"); // Código de pais, selector
  
  const [connIncoming, setConnIncomming] = useState(null);
  const [incomingCallStatus, setIncomingCallStatus] = useState("");

  const [selectedReasons, setSelectedReasons] = useState([]);
  const [selectedServiceIds, setSelectedServiceIds] = useState([]);
  
  const handleReasonsChange = (event) => {
    const selectedValues = event.target.value;
    setSelectedReasons(selectedValues);
    const reasonsString = selectedValues.join(', ');
    setReason(reasonsString);
  };

  // Función para manejar cambios en la selección de servicios
  const handleServicesChange = (event) => {
    const selectedValues = event.target.value;
    setSelectedServiceIds(selectedValues);
    
    // Actualizar el estado de servicios de interés con los nombres de servicios
    const selectedServiceNames = services
      .filter(service => selectedValues.includes(service.id))
      .map(service => service.name);
    
    const servicesString = selectedServiceNames.join(', ');
    setServicesOfInterest(servicesString);
  };

  // Función para verificar si un servicio está seleccionado
  const isServiceSelected = (serviceId) => {
    return selectedServiceIds.includes(serviceId);
  };

  // Pre-llenar el número de teléfono si hay datos del cliente
  useEffect(() => {
    if (client && (client.telefono || client.telefonoGenerales)) {
      // Extraer solo los números del teléfono
      const phoneNumbers = (client.telefono || client.telefonoGenerales).replace(/\D/g, '');
      setPhone(phoneNumbers);
    } else {
      setPhone("");
    }
  }, [client]);

  const fetchData = async () => {
    try {
      const response = await axios.post(`${WEBHOOK}/token/generate`, {
        page: window.location.pathname,
        worker: user.id, // Incluye el workerId aquí
      });
      const data = response.data;

      // Setup Twilio.Device
      const twilioDevice = new Device(data.token, {
        codecPreferences: ["opus", "pcmu"],
        fakeLocalDTMF: true,
        enableRingingState: true,
      });

      // Set device immediately and register for incoming
      setDevice(twilioDevice);
      try {
        await twilioDevice.register();
      } catch (registerError) {
        updateCallStatus("Error: " + registerError.message);
      }

      twilioDevice.on("registered", () => {
        updateCallStatus("Listo");
      });

      twilioDevice.on("error", (error) => {
        updateCallStatus("Error: " + error.message);
      });

      twilioDevice.on("cancel", () => {
        updateCallStatus("Listo");
      });

      twilioDevice.on("connect", (conn) => {
        conn.worker = user.id; // Incluye el worker ID en la conexión
        if ("phoneNumber" in conn.message) {
          updateCallStatus("En llamada con " + conn.message.phoneNumber);
          setCallState("En llamada");
        } else {
          updateCallStatus("Linea Ocupada");
        }
      });

      twilioDevice.on("incoming", (conn) => {
        setIncomingCallStatus("Llamada entrante");
        setConnIncomming(conn);
        setOpen(true)
      });

      twilioDevice.on("disconnect", (conn) => {
        updateCallStatus("Desconectado");
        setCallState("Usuario desconectado");
        
        // Disparar evento de fin de llamada
        dispatch(setCallEnded(true));
      });

    } catch (err) {
      console.log(err);
      console.log("Could not get a token from the server!");
    }
  };

  useEffect(() => {
    fetchData();
    return () => {
      if (device) {
        try {
          device.unregister();
        } catch (e) {
          // ignore
        }
        setDevice(null);
        setCallStatus("Offline");
      }
    };
  }, []);

  const updateCallStatus = (status) => { // Actualiza el estado de la llamada
    setCallStatus(status);
  };

  // Función para validar si un string tiene exactamente 24 caracteres (ObjectId de MongoDB)
  const isValidUUID = (str) => {
    return str.trim().length === 24;
  };

  const [quotes, setQuotes] = useState("");
  const [notes, setNotes] = useState("");
  const [reason, setReason] = useState("");
  const [servicesOfInterest, setServicesOfInterest] = useState("");

  function callCustomer(phoneNumber) {
    updateCallStatus("Llamando a  " + phoneNumber + "...");
    setCallState("Llamando");

    if (!device) {
      updateCallStatus("Inicializando dispositivo de llamada...");
      setCallState("");
      return;
    }

    var params = { phoneNumber: phoneNumber, workerId: user.id, category: CalculateUserCategory(user) };
    
    if (client) {
      params.clientId = client.id;
    }
    if (quoteId) {
      // Filtrar solo las cotizaciones válidas (24 caracteres)
      const validQuotes = quotes
        .split(',')
        .map(quote => quote.trim())
        .filter(quote => quote.length === 24);
      
      const allQuotes = [quoteId, ...validQuotes];
      params.quotesId = allQuotes.join(', ');
    }
    if (notes) {
      params.notes = notes;
    }
    if (reason) {
      params.reason = reason;
    }
    if (servicesOfInterest) {
      params.servicesOfInterest = servicesOfInterest;
    }

    device.connect({ params }).catch((err) => {
      updateCallStatus("Error: " + (err?.message || 'No se pudo conectar'));
      setCallState("");
    });
  }

  function hangUp() { // Colgar llamada
    device.disconnectAll();
    setCallState("");
    
    // Disparar evento de fin de llamada
    dispatch(setCallEnded(true));
  }

  const handleHangup = () => {
    if (connIncoming) {
      connIncoming.disconnect();
      setIncomingCallStatus("");
      setConnIncomming(null);
      
      // Disparar evento de fin de llamada
      dispatch(setCallEnded(true));
    }
  };

  const keyboard = [ // Teclado
    { id: 1, value: "1" },
    { id: 2, value: "2" },
    { id: 3, value: "3" },
    { id: 4, value: "4" },
    { id: 5, value: "5" },
    { id: 6, value: "6" },
    { id: 7, value: "7" },
    { id: 8, value: "8" },
    { id: 9, value: "9" },
  ];

  const deleteLastCharacter = () => {
    const newString = phone.slice(0, -1);
    setPhone(newString);
  };

  return (
    <DrawerRight maxWidth={600} title={"Nueva llamada"} open={open} onClose={() => {
      onClose();
      setQuotes("");
      setNotes("");
      setReason("");
      setSelectedReasons([]);
      setServicesOfInterest("");
      setSelectedServiceIds([]);
    }}>
      <div>
        {/* Información del cliente y cotización */}
        {(client || quoteId) && (
          <div className="flex flex-col gap-4 max-w-lg mx-auto mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
            {client && (
              <div className="">
                <p className="text-xs font-semibold text-blue-800">Cliente:</p>
                <p className="text-xs text-blue-700">{client.nombreComercial || client.razonSocial}</p>
                {client.telefono && (
                  <p className="text-xs text-blue-600">{client.telefono}</p>
                )}
              </div>
            )}
            {quoteId && (
              <div>
                <p className="text-xs font-semibold text-blue-800">Cotización:</p>
                <p className="text-xs text-blue-700">{quoteId}</p>
              </div>
            )}

            <InputFormValue
              title="Cotizaciones vinculadas"
              info="Solo se guardarán las cotizaciones válidas (24 caracteres)."
              value={quotes}
              setValue={(value) => setQuotes(value)}
              icon={<FaPen />}
              placeholder="Cotizaciones vinculadas, separadas por comas"
              type="text"
            />

            {/* Visualización de cotizaciones vinculadas */}
            {quotes && quotes.trim() !== '' && (
              <div className="mt-2">
                <label className="text-xs text-gray-600 mb-1 block">
                  Cotizaciones identificadas:
                </label>
                <div className="flex flex-wrap gap-2">
                  {quotes.split(',').map((quoteId, index) => {
                    const trimmedQuoteId = quoteId.trim();
                    if (trimmedQuoteId) {
                      const isValid = isValidUUID(trimmedQuoteId);
                      return (
                        <div
                          key={index}
                          className={`inline-flex items-center px-2 py-1 text-xs rounded-full border ${
                            isValid 
                              ? 'bg-blue-100 text-blue-800 border-blue-200' 
                              : 'bg-red-100 text-red-800 border-red-200'
                          }`}
                        >
                          <FaFileInvoiceDollar className="mr-1" />
                          ID: {trimmedQuoteId}
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            )}

            <InputFormValue
              title="Notas"
              info="Notas de la llamada."
              value={notes}
              setValue={(value) => setNotes(value)}
              icon={<FaNoteSticky />}
              placeholder="Notas"
              type="textarea"
            />

            <div>
              <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                Motivos de la llamada
              </label>
              <div className="flex">
                <span className="text-xs inline-flex items-center px-3 text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                  <FaQuestionCircle />
                </span>
                <FormControl sx={{ flex: 1, minWidth: 0 }}>
                  <Select
                    multiple
                    value={selectedReasons}
                    onChange={handleReasonsChange}
                    input={
                      <OutlinedInput 
                        sx={{ 
                          fontSize: '0.875rem',
                          borderRadius: '0 0.5rem 0.5rem 0',
                          backgroundColor: '#f9fafb',
                          border: '1px solid #d1d5db',
                          color: '#111827',
                          height: '42px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: '2px solid #3b82f6'
                          },
                          '& .MuiSelect-select': {
                            padding: '0.625rem',
                            fontSize: '0.875rem',
                            color: '#111827'
                          }
                        }}
                      />
                    }
                    renderValue={(selected) => {
                      if (selected.length === callReasons.length) return "Todos los motivos";
                      if (selected.length === 0) return "Seleccionar motivos";
                      return selected.join(', ');
                    }}
                    displayEmpty
                    MenuProps={{
                      disablePortal: false,
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 6.5,
                          width: 250,
                          zIndex: 99999,
                          position: 'fixed'
                        }
                      },
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      style: {
                        zIndex: 99999
                      }
                    }}
                  >
                    {callReasons.map((reason, index) => {
                      const isSelected = selectedReasons.includes(reason.value);
                      return (
                        <MenuItem key={index} value={reason.value} sx={{ height: "40px", fontSize: '0.875rem' }}>
                          <Checkbox 
                            checked={isSelected} 
                            sx={{ padding: '4px' }}
                          />
                          <ListItemText 
                            primary={reason.label} 
                            primaryTypographyProps={{ 
                              fontSize: '0.875rem', 
                              fontFamily: "Poppins, sans-serif",
                              color: '#111827'
                            }}
                          />
                        </MenuItem>
                      );
                      })}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div>
              <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                Servicios relacionados
              </label>
              <div className="flex">
                <span className="text-xs inline-flex items-center px-3 text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                  <FaBoxOpen />
                </span>
                <FormControl sx={{ flex: 1, minWidth: 0 }}>
                  <Select
                    multiple
                    value={selectedServiceIds}
                    onChange={handleServicesChange}
                    input={
                      <OutlinedInput 
                        sx={{ 
                          fontSize: '0.875rem',
                          borderRadius: '0 0.5rem 0.5rem 0',
                          backgroundColor: '#f9fafb',
                          border: '1px solid #d1d5db',
                          color: '#111827',
                          height: '42px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: '2px solid #3b82f6'
                          },
                          '& .MuiSelect-select': {
                            padding: '0.625rem',
                            fontSize: '0.875rem',
                            color: '#111827'
                          }
                        }}
                      />
                    }
                    renderValue={(selected) => {
                      if (selected.length === services.length) return "Todos los servicios";
                      if (selected.length === 0) return "Seleccionar servicios";
                      
                      // Obtener los nombres de servicios basados en los IDs seleccionados
                      const selectedServiceNames = services
                        .filter(service => selected.includes(service.id))
                        .map(service => service.name);
                      
                      return selectedServiceNames.join(', ');
                    }}
                    displayEmpty
                    MenuProps={{
                      disablePortal: false,
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 6.5,
                          width: 250,
                          zIndex: 99999,
                          position: 'fixed'
                        }
                      },
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      style: {
                        zIndex: 99999
                      }
                    }}
                  >
                    {services.map((service, index) => {
                      const isSelected = isServiceSelected(service.id);
                      return (
                        <MenuItem key={service.id} value={service.id} sx={{ height: "40px", fontSize: '0.875rem' }}>
                          <Checkbox 
                            checked={isSelected} 
                            sx={{ padding: '4px' }}
                          />
                          <ListItemText 
                            primary={service.name} 
                            primaryTypographyProps={{ 
                              fontSize: '0.875rem', 
                              fontFamily: "Poppins, sans-serif",
                              color: '#111827'
                            }}
                          />
                        </MenuItem>
                      );
                      })}
                  </Select>
                </FormControl>
              </div>
            </div>


          </div>
        )}
        <div className="max-w-lg mx-auto mb-6">
          <div className="flex items-center gap-0">
            <select
              id="countries"
              value={dialCode}
              onChange={(e) => setDialCode(e.target.value)}
              className="bg-gray-50   border-e-0 border-gray-300 text-gray-900 text-sm  rounded-s-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 "
            >
              {contrycodes.map((e) => (
                <option key={e.name} value={e.dial_code}>
                  {e.code} ({e.dial_code})
                </option>
              ))}
            </select>

            <label
              htmlFor="phone-input"
              className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Phone number:
            </label>
            <div className="relative w-full">
              <input
                type="text"
                id="phone-input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-e-lg border-s-0 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                placeholder="123-456-7890"
                required
              />
            </div>
          </div>
        </div>

        <div className="max-w-lg mx-auto w-full">
          <div className=" grid grid-cols-3 gap-1 mb-1 ">
            {keyboard.map((e) => (
              <button
                key={e.id}
                onClick={() => setPhone(phone + e.value)}
                className="bg-orange-50  active:bg-black font-bold rounded-md p-3 gap-0.5 hover:bg-orange-400 hover:text-white "
                type="button"
              >
                {e.value}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-1">
            <button
              onClick={() => setPhone(phone + "0")}
              className="bg-orange-50 col-span-2  active:bg-black font-bold rounded-md p-3 gap-0.5 hover:bg-orange-400 hover:text-white "
              type="button"
            >
              0
            </button>

            <button
              onClick={deleteLastCharacter}
              className="bg-red-50 text-red-700 flex justify-center  items-center  active:bg-black font-bold rounded-md p-3 gap-0.5 hover:bg-red-400 hover:text-white "
              type="button"
            >
              <FaTrash />
            </button>
          </div>
        </div>

        <div className="mt-4 flex justify-center font-bold">
          <span
            className={`p-2 rounded-lg ${
              callState === "En llamada"
                ? "bg-green-500 text-green-700 bg-opacity-5 shadow-lg"
                : ""
            }`}
          >
            {callStatus}
          </span>
        </div>

        <div className="grid grid-cols-2 mt-10 max-w-xs mx-auto gap-4">
          <div  className=" flex justify-center">
            <button
              type="button"
              disabled={
                callState === "Llamando" || callStatus === "Linea Ocupada"
              }
              onClick={() => callCustomer(dialCode + phone)}
              className={` ${
                callState === "Llamando" ? "animate-ping" : ""
              }  p-5 flex justify-center items-center rounded-full bg-green-700 bg-opacity-10 hover:bg-green-800 hover:bg-opacity-20 text-green-600 focus:ring-4 focus:ring-blue-300 font-medium  text-sm  focus:outline-none`}
            >
              <div>
                <FaPhone className="h-8 w-8" />
              </div>
            </button>
          </div>

          <div className=" flex justify-center">
            <button
              type="button"
              onClick={hangUp}
              className={` ${
                callState === "Llamando" ? "" : ""
              }  p-5   flex justify-center items-center rounded-full bg-red-700 bg-opacity-10 hover:bg-red-800 hover:bg-opacity-20 text-red-600 focus:ring-4 focus:ring-red-300 font-medium  text-sm  focus:outline-none`}
            >
              <div>
                <MdClose className=" h-8 w-8" />
              </div>
            </button>
          </div>
        </div>

        <div className=" flex justify-center">
          {connIncoming && (
            <>
              {incomingCallStatus === "Llamada entrante" ? (
                <IncomingCall
                  connection={connIncoming}
                  setIncomingCallStatus={setIncomingCallStatus}
                  setConnIncomming={setConnIncomming}
                />
              ) : (
                <OnCall connection={connIncoming} handleHangup={handleHangup} />
              )}
            </>
          )}
        </div>
      </div>
    </DrawerRight>
  );
};

export default TwilioPhoneDrawer;